import React from 'react';
import "./Thankyou.css";
import "../../assets/css/app.css";
import cheked from "../../assets/imgs/icons/cheked.png";

function Thankyou() {
  return (
    <div className="tY">
        <div className="maxW">
           <div className="tyMn">
              <img src={cheked} alt="product-img" />
           <h2>Thank You!</h2>
            <span>Your form has been successfully submitted</span>
            <h6>We will respond you  soon.</h6>
            <a href="/">Back to Home</a>
           </div>
         </div>
       </div>
  )
}

export default Thankyou